"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebmFile = void 0;
const tslib_1 = require("tslib");
const WebmContainer_1 = require("./WebmContainer");
class WebmFile extends WebmContainer_1.WebmContainer {
    constructor(source) {
        super("File");
        this.setSource(source);
    }
    getType() {
        return "File";
    }
    toBlob(mimeType = "video/webm") {
        return new Blob([this.source.buffer], { type: mimeType });
    }
    static blobToArray(blob) {
        return new Promise((resolve, reject) => {
            try {
                const reader = new FileReader();
                reader.onloadend = () => {
                    try {
                        resolve(new Uint8Array(reader.result));
                    }
                    catch (ex) {
                        reject(ex);
                    }
                };
                reader.readAsArrayBuffer(blob);
            }
            catch (ex) {
                reject(ex);
            }
        });
    }
    static fromBlob(blob) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const array = yield WebmFile.blobToArray(blob);
            return new WebmFile(array);
        });
    }
}
exports.WebmFile = WebmFile;
//# sourceMappingURL=WebmFile.js.map